var A=function(e){return e.MEAT="meat",e.VEGETARIAN="vegetarian",e.BEGAN="vegan",e}({});export{A as NutritionStatus};